import styled from 'styled-components';

const TabBar = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.medium || '1.25rem'};
  border-bottom: 2px solid ${({ theme }) => theme.colors.brandLighter || 'rgba(130, 22, 146, 0.2)'};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing.small || '0.625rem'};
  }
`;

export default TabBar;
